import { render, staticRenderFns } from "./historyUpdate.vue?vue&type=template&id=2bc0b0e0"
import script from "./historyUpdate.vue?vue&type=script&lang=js"
export * from "./historyUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports